/*
 * @Description:
 * @Author: Luke Z
 * @Date: 2021-03-23 14:21:08
 * @LastEditors: Jack Deng
 * @LastEditTime: 2021-11-12 16:00:15
 * @FilePath: /unifyxp-v2-store-portal/src/pages/SalesChannelContentEditor/SalesChannelEditorShoppingCartPage/SalesChannelEditorShoppingCartPage.tsx
 */
import React from 'react';

import css from './css.less';

import BasicPageHOC from 'src/constrains/SalesChannelPreviewPageComponents/SalesChannelContentBasicPageHOC';

import RouteBlock from './RouteBlock';

//import { useParams } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { useParams } from 'react-router-dom';
import { dispatch } from 'src/store';

import PageWrapper from '../../../constrains/SalesChannelPreviewPageComponents/PageWrapper/PageWrapper';
import RightConfigWrapper from '../../../constrains/SalesChannelPreviewPageComponents/RightConfigWrapper';
//import Preview from './Preview';

//import { IParams } from 'src/pages/SalesChannelContentEditor/common';

import { WebSiteSubType } from '@/src/types/common/SalesChannel';
import { useI18n } from 'src/hooks/useRouterChange';
import { convertDataFromReduxToServer } from 'src/pages/SalesChannelContentEditor/SalesChannelEditorShoppingCartPage/tools';
import { getContentButtonThemes } from 'src/request/salesChannel/content';
import { i18nGet } from 'src/tools/tools';
import ButtonText from './ButtonText';
import CloneBtn from './CloneButton';
import EmptyStateSetting from './EmptyStateSetting';
import FeaturedProducts from './FeaturedProducts';
import NoticeBoard from './NoticeBoard';
import { SalesChannelModeAccessControlHOC } from 'src/constrains/SalesChannelModeAccessControl';
import { DEFAULT_MULTI_LANGUAGE_PARAMS } from '@/src/types/server/params';
import TranslationTip from 'src/constrains/SalesChannelAITranslation/TranslationTip';

import {
  fetchContentShoppingCart,
  getHasModified,
  //isNoticeBoardOpening,
  getLoaded,
  getSalesChannel,
  getSalesChannelName,
  getState,
  getTranslationState,
  resetData,
  //submitContentHomepage,  submitContentShoppingCart,
  submitContentShoppingCart,
  validation,
  translateContentShoppingCart,
} from './slice';

const SalesChannelEditorShoppingCartPage = (props) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const {
    onDiscard,
    onGoBack,
    submitData,
    hasModified,
    salesChannel,
    salesChannelName,
    isOnPrimaryLanguage,
    //currentSize,
    currentStyle,
    isMini,
    translationEnabled,
    translationLoading,
    uuid,
    loaded,
  } = props;

  const hideRightPart = !isMini;

  const _params: {
    saleChannelUuid: string;

    contentUuid: string;
  } = useParams();
  const { contentUuid } = _params;

  const [themeList, setThemesList] = React.useState([]);

  const multiLanguageParams = DEFAULT_MULTI_LANGUAGE_PARAMS;
  React.useEffect(() => {
    getContentButtonThemes(contentUuid).then((res) => {
      setThemesList(res);
      //console.log(res);
    });
  }, []);

  const _d = useDispatch();
  // const _history = useHistory();
  //const _params: IParams = useParams();
  //const { contentUuid } = _params;
  React.useEffect(() => {
    // _d(
    //   fetchContentShoppingCart({
    //     uuid: contentUuid,
    //   }),
    // );

    return () => {
      _d(resetData());
    };
  }, []);
  const handleOnTranslate = (translationEnabled) => {
    _d(
      translateContentShoppingCart({
        uuid,
        translationEnabled,
        multiLanguageParams,
      }),
    );
  };
  const _leftChild = (
    <div className={css.left}>
      {translationEnabled && !isOnPrimaryLanguage && (
        <div className={css.translationTip}>
          <TranslationTip />
        </div>
      )}
      {/* <Preview isNoticeBoardOpening={isNoticeBoardOpening} /> */}
    </div>
  );

  const WrappedShoppingCartContent = React.useMemo(
    () =>
      SalesChannelModeAccessControlHOC(
        ({
          themeList: themeListProp,
          isOnPrimaryLanguage: isPrimary,
          hideRightPart: withoutCollapse,
          translationEnabled: translationEnabledProp,
          currentStyle: currentStyleProp,
        }) => {
          return (
            <>
              <RightConfigWrapper
                title={getI18n('general.sider.shoppingCartPage')}
                wrapperClassName={withoutCollapse ? 'wrapperWithoutLeft' : ''}
                elements={[
                  {
                    body: (
                      <React.Fragment>
                        {!isPrimary && (
                          <CloneBtn disabled={translationEnabledProp} />
                        )}
                        <EmptyStateSetting
                          isPrimary={isPrimary}
                          collapseOpenDefault={withoutCollapse}
                          disabled={translationEnabledProp}
                        />
                        <ButtonText
                          themeList={themeListProp}
                          isPrimary={isPrimary}
                          collapseOpenDefault={withoutCollapse}
                          isResponsive={
                            currentStyleProp === WebSiteSubType.ResponsivePage
                          }
                          disabled={translationEnabledProp}
                        />
                      </React.Fragment>
                    ),
                    key: 'TopConfig',
                  },
                  {
                    body: (
                      <React.Fragment>
                        <FeaturedProducts
                          isPrimary={isPrimary}
                          collapseOpenDefault={withoutCollapse}
                        />
                        <NoticeBoard
                          isPrimary={isPrimary}
                          collapseOpenDefault={withoutCollapse}
                          disabled={translationEnabledProp}
                        />
                      </React.Fragment>
                    ),
                    key: 'FeaturedProducts',
                  },
                ]}
              />
            </>
          );
        },
        { isscMode: true },
      ),
    [],
  );

  const _rightChild = loaded ? (
    <WrappedShoppingCartContent
      themeList={themeList}
      isOnPrimaryLanguage={isOnPrimaryLanguage}
      hideRightPart={hideRightPart}
      translationEnabled={translationEnabled}
      currentStyle={currentStyle}
    />
  ) : null;
  return (
    <React.Fragment>
      <RouteBlock hasModified={hasModified} />
      {translationEnabled && !isOnPrimaryLanguage && !isMini && (
        <TranslationTip />
      )}
      <PageWrapper
        headerConfig={{
          hasModified,
          submit: submitData,
          salesChannelContentData: salesChannel || {},
          salesChannelName: salesChannelName,
          onDiscard,
          onGoBack,
          hasStyleSelect: false,
          handleOnTranslate,
          translationEnabled,
          translationLoading,
        }}
        hideRightPart={hideRightPart}
        withoutCollapse={hideRightPart}
        leftChild={hideRightPart ? _rightChild : _leftChild}
        rightChild={hideRightPart ? _leftChild : _rightChild}
      />
    </React.Fragment>
  );
};
export default BasicPageHOC(SalesChannelEditorShoppingCartPage, {
  getState,
  convertDataFromReduxToServer,
  submit: submitContentShoppingCart,
  siteStyleInParams: true,
  previewSizeInParams: true,
  getHasModified,
  getSalesChannel,
  getSalesChannelName,
  validation,
  getLoaded,
  getTranslationState,
  queryData: (params, qParams) => {
    const { contentUuid } = params;
    dispatch(
      fetchContentShoppingCart({
        uuid: contentUuid,
        params: qParams,
      }),
    );
  },
});
